module.exports = __webpack_public_path__ + "static/img/fish13.fa479bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish13.png
// module id = K/Fg
// module chunks = 0